$(() => {
  let max = $('.num_parent').text();

  $('textarea').on('input', (e) => {
    let text = $(e.currentTarget)
      .val()
      .replace(/\r\n|\n\r|\r|\n/g, '\r\n');
    let textLength = text.length;

    if (textLength <= max) {
      $('.num_child').text(textLength);
    } else {
      $(e.currentTarget).val(text.substring(0, max).replace(/\r$/, ''));
    }
  });
});
